export default __webpack_public_path__ + "static/media/Snd5.0ddbf84d.mp3";